import React, { useContext, useEffect } from "react";
import axios from "axios";
import SystemContext from "../context/System";
import SystemsContext from "../context/Systems";
import SexySelector from "../components/SexySelector";

const AuthLayout = (props) => {
  const { children } = props;
  const { system, setSystem } = useContext(SystemContext);
  const { systems, setSystems } = useContext(SystemsContext);

  const set_selected_system = async () => {
    const requested_system = localStorage.getItem("system");
    let selected_system = requested_system != null ? requested_system : "zi";
    const selected_system_data = await axios(
      `${process.env.REACT_APP_API_URL}/systems/get?system=${selected_system}`
    );
    setSystem(selected_system_data.data.record);
    const all_systems = await axios(
      `${process.env.REACT_APP_API_URL}/systems/get`
    );

    setSystems(all_systems.data.record);
  };

  const handle_my_load = () => {
    set_selected_system();
  };

  useEffect(() => {
    if (!systems) {
      handle_my_load();
    }
  }, []); // eslint-disable-line

  return (
    systems && (
      <section id='auth' className={system.identifier + "-bkgd"}>
        <div className='container'>
          <div className='auth-con d-flex flex-column flex-nowrap justify-content-between rounded text-white'>
            <div>
              <SexySelector />
              {children}
            </div>
            <small className='fw-light text-center'>
              © Zeal Innovations, {new Date().getFullYear()} &amp; beyond. All
              Rights Reserved
            </small>
          </div>
        </div>
      </section>
    )
  );
};

export default AuthLayout;
